import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';
import './AdminLayout.css';

interface AdminLayoutProps {
    children?: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    return (
        <div className="admin-wrapper">
            <AdminSidebar collapsed={collapsed} onToggle={toggleSidebar} />
            <div className="admin-main">
                <AdminTopbar onToggleSidebar={toggleSidebar} />
                <main className="admin-content-body">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
